var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import UploadDropzone from '@/Jetstream/UploadDropzone';
import FileUploadService from '@/Pages/Certificate/Partials/FileUploadService';
import { router } from '@inertiajs/react';
import axios from 'axios';
import { useReducer, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import { useRoute } from 'ziggy-js';
import { Ziggy } from '@/ziggy.js';
;
export default function DocumentUpload(_a) {
    var clientForm = _a.clientForm, documents = _a.documents, documentType = _a.documentType;
    var route = useRoute(Ziggy);
    var _b = useState([]), selectedFiles = _b[0], setSelectedFiles = _b[1];
    var _c = useState(0), progress = _c[0], setProgress = _c[1];
    var _d = useState(""), message = _d[0], setMessage = _d[1];
    var _e = useState([]), fileInfos = _e[0], setFileInfos = _e[1];
    var _f = useReducer(function (x) { return x + 1; }, 0), ignored = _f[0], forceUpdate = _f[1];
    var deleteFile = function (file) {
        axios.delete(route('client-public-form.delete-upload', {
            // team: team.id,
            // branch: branch.id,
            // certificate: certificate.id,
            clientForm: clientForm,
            media_uuid: file.uuid
        })).then(function (resp) {
            router.reload({ only: ['certificate'] });
        }, function (err) {
        });
    };
    var upload = function (file) {
        setProgress(0);
        var allfiles = __spreadArray(__spreadArray([], selectedFiles, true), [file], false);
        console.log('allfiles', allfiles);
        FileUploadService.upload(route('client-public-form.upload', { clientForm: clientForm, type: documentType }), file, function (event) {
            console.log('onUploadProgress', event);
            console.log('selectedFiles', selectedFiles);
            allfiles.map(function (_file) {
                if (file === _file) {
                    file.progress = Math.round((100 * event.loaded) / event.total);
                    _file.progress = Math.round((100 * event.loaded) / event.total);
                    console.log('file progress', file, file.progress);
                }
                return _file;
            });
            setSelectedFiles(allfiles);
            forceUpdate();
        })
            .then(function (response) {
            setMessage(response.data.message);
            setSelectedFiles(allfiles.map(function (_file) {
                if (file !== _file) {
                    return _file;
                }
            }));
            router.reload({ only: ['certificate'] });
        })
            .catch(function () {
            setProgress(0);
            setMessage("Could not upload the file!");
        });
        setSelectedFiles([]);
    };
    var _g = useDropzone({ accept: "application/pdf,image/png,image/jpg,image/jpeg" }), getRootProps = _g.getRootProps, getInputProps = _g.getInputProps, isDragActive = _g.isDragActive, isDragReject = _g.isDragReject;
    var _h = useState(false), open = _h[0], setOpen = _h[1];
    var _j = useState(null), file = _j[0], setFile = _j[1];
    return _jsxs(_Fragment, { children: [_jsx("div", __assign({ className: "mb-2" }, { children: _jsx(UploadDropzone, { upload: upload }) })), documents.length > 0 && _jsxs("ul", __assign({ id: "document-list", role: "list", className: "border border-gray-200 rounded-md divide-y divide-gray-200" }, { children: [documents.map(function (file, index) {
                        var _a;
                        return (_jsxs("li", __assign({ className: "pl-3 pr-4 py-3 flex items-center justify-between text-sm" }, { children: [_jsxs("div", __assign({ className: "w-0 flex-1 flex items-center" }, { children: [_jsx("img", { src: "/media/thumb/" + ((_a = file.custom_properties.thumbs) === null || _a === void 0 ? void 0 : _a[0]), alt: "", className: "h-12 w-12 object-contain border border-gray-300 rounded" }), _jsx("span", __assign({ className: "ml-2 flex-1 w-0 truncate" }, { children: file.file_name }))] })), _jsx("div", __assign({ className: "ml-4 flex-shrink-0" }, { children: _jsx("button", __assign({ onClick: function () { return deleteFile(file); }, className: "font-medium text-red-600 hover:text-red-500" }, { children: "Delete" })) }))] }), index));
                    }), selectedFiles.map(function (file, index) {
                        return (file && _jsxs("li", __assign({ className: "" }, { children: [_jsxs("div", __assign({ className: "pl-3 pr-4 py-3 flex items-center justify-between text-sm" }, { children: [_jsx("div", __assign({ className: "w-0 flex-1 flex items-center" }, { children: _jsx("span", __assign({ className: "ml-2 flex-1 w-0 truncate" }, { children: file.path })) })), _jsx("div", __assign({ className: "ml-4 flex-shrink-0" }, { children: _jsxs("a", __assign({ href: "#", className: "font-medium text-sky-600 hover:text-sky-500" }, { children: [file.progress, "%"] })) }))] })), _jsx("div", { className: "h-2 bg-sky-500 text-center text-sm text-white", style: { width: file.progress + "%" } })] }), index));
                    })] }))] });
}
